import { render, staticRenderFns } from "./DubugTest.vue?vue&type=template&id=3c3374a4&scoped=true&"
import script from "./DubugTest.vue?vue&type=script&lang=js&"
export * from "./DubugTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3374a4",
  null
  
)

export default component.exports